import { Base64 } from "js-base64";
import * as echarts from "echarts";

export default class Utils {
  static sendSocketData(
    method: string,
    data: any = {},
    callBack: Function,
    uuid: string
  ) {
    if (window["systemWebSocket"]) {
      window["systemWebSocket"].sendData(
        Object.assign(data, { method: method }),
        callBack,
        uuid
      );
    }
  }
  /**获取地图对象 */
  static getMap(): any {
    return window["engine"];
  }
  /**
   * 获取ddmap_params
   */
  static getInitParams() {
    let params = window.sessionStorage.getItem("MapParams") || "{}";
    return JSON.parse(params);
  }

  /**
   * 获取AppServerIP
   */
  static getAppServerIP() {
    let json = this.getInitParams();
    return json.appServerIP;
  }
  /**
   * 获取WebSocketIP
   */
  static getThirdWebSocketIP() {
    let json = this.getInitParams();
    return json.ThirdWS;
  }

  /**
   * 获取webIP
   */
  static webIP() {
    let json = this.getInitParams();
    return json.webIP;
  }
  /**
   * 获取后台系统地址
   */
  static webServerIP() {
    let json = this.getInitParams();
    return json.webServerIP;
  }
  static backstageAccessAddress() {
    let json = this.getInitParams();
    return json.backstageAccessAddressIp;
  }

  /**获取 */
  static getHdyServers() {
    let json = this.getInitParams();
    return json.HdyServers["ip"];
  }
  /**获取 */
  static getHdyServerHeader() {
    let json = this.getInitParams();
    return json.HdyServers["hearder"];
  }
  /**获取 */
  static getHwServersIP() {
    let json = this.getInitParams();
    return json.HdyServers["ip"];
  }
  /**获取 */
  static getHwServersHeader() {
    let json = this.getInitParams();
    return json.HdyServers["hearder"];
  }
  /**
   * 获取天翼接口IP
   * @returns {string}
   */
  static getThirdServerIP() {
    let json = this.getInitParams();
    return json.ThirdServerIP;
  }
  /**
   * 获取token
   */
  static getToken() {
    return window.sessionStorage.getItem("ddmap_token");
  }

  /** 设置token */
  static setToken(token) {
    window.sessionStorage.setItem("ddmap_token", token);
  }
  /** 转成base64 */
  public static toBase64(obj: any) {
    return Base64.toBase64(obj);
  }
  /** base64转回原对象 */
  public static fromBase64(obj) {
    return Base64.fromBase64(obj);
  }
  public static getUUID(len = 32) {
    let radix = 16;
    let chars =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
        ""
      );
    let uuid: any = [];
    let i: any = 0;
    radix = radix || chars.length;
    if (len) {
      for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
      var r;
      uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
      uuid[14] = "4";
      for (i = 0; i < 36; i++) {
        if (!uuid[i]) {
          r = 0 | (Math.random() * 16);
          uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
        }
      }
    }
    return uuid.join("");
  }
  /** 数组删除对象 */
  public static listSplice(list: Array<any>, obj: any) {
    if (obj instanceof Function) {
      list.forEach((item, idx) => {
        if (item.toString() === obj.toString()) list.splice(idx, 1);
      });
    } else {
      let index = list.indexOf(obj);
      if (index >= 0) list.splice(index, 1);
    }
  }

  /** 显示信息 */
  public static showMsg(text: string, type: string = "info") {
    // message[type](text);
  }
  public static equals(obj1, obj2) {
    if (obj1 === undefined) return false;
    let keys = Object.keys(obj2);
    for (let i = 0; i < keys.length; i++) {
      if (obj1[keys[i]] !== obj2[keys[i]]) return false;
    }
    return true;
  }
  /** 根据数据生成提交的Form表单 */
  public static recordToForm(record: {}) {
    let formData = new FormData();
    Object.keys(record).map((key) => {
      let values =
        record[key] instanceof Object
          ? JSON.stringify(record[key])
          : record[key];
      return formData.append(key, values);
    }, this);
    return formData;
  }
  /** 判断是否为空 */
  public static isEmpty(str: any) {
    return (
      str === null ||
      str === undefined ||
      str === "" ||
      Object.keys(str).length === 0
    );
  }
  /** 时间格式化 */
  public static dateFormat(date: any, format: string = "yyyy-MM-dd hh:mm:ss") {
    let o = {
      "M+": date.getMonth() + 1, //月份
      "d+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    };
    if (/(y+)/.test(format))
      format = format.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    for (var k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ("00" + o[k]).substr(("" + o[k]).length)
        );
    return format;
  }
  /** 获取类名称 */
  public static getClassName(cls: string) {
    return cls.split("extends")[0].replace("class", "").trim();
  }
  public static eval(str: string) {
    let fn = Function;
    return new fn("return " + str)();
  }
  public static compareJson(obj1: any, obj2: any) {
    if (!this.isJsonObj(obj1) || !this.isJsonObj(obj2)) return false;
    var _keys = Object.keys(obj1);
    if (_keys.length !== Object.keys(obj2).length) return false;
    let flag = false;
    for (var _key in obj1) {
      if (!obj2.hasOwnProperty(_key)) return false;
      var value1 = obj1[_key];
      var value2 = obj2[_key];
      if (this.isJsonObj(value1)) return this.compareJson(value1, value2);
      if (String(value1) !== String(value2)) return false;
      flag = true;
    }
    return flag;
  }
  public static isJsonObj(data: any) {
    return (
      typeof data === "object" &&
      Object.prototype.toString.call(data).toLowerCase() ===
        "[object object]" &&
      !data.length
    );
  }

  /**
   * dom移动
   * */
  public static moveModal(node, NodeUp = 2) {
    var modalNode;
    if (this.isEmpty(node)) {
      return;
    }
    if (NodeUp === 1) {
      modalNode = node.parentNode;
    }
    if (NodeUp === 2) {
      modalNode = node.parentNode.parentNode;
    }
    node.onmousedown = function (ev) {
      var ov = ev;
      var disX = ov.clientX - modalNode.offsetLeft;
      var disY = ov.clientY - modalNode.offsetTop;
      document.onmousemove = function (e) {
        var ov = e;
        modalNode.style.left = ov.clientX - disX + "px";
        modalNode.style.top = ov.clientY - disY + "px";
        if (ov.clientY + 100 - disY > document.body.clientHeight) {
          document.body.scrollTop =
            ov.clientY + 100 - disY - document.body.clientHeight;
        }
      };
      document.onmouseup = function (ov) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      return false;
    };
  }
  /** 时间补零 */
  static Appendzero(obj: number) {
    if (obj < 10) return "0" + obj;
    else return obj;
  }
  /** 重置状态 */
  static clearAllLayers() {
    window["engine"].Api.Layers.showLayer("ShuiGuan", false);
    window["engine"].Api.Layers.showLayer("MenJin_Icon", false);
    window["engine"].Api.Layers.showLayer("JianKong", false);
    window["engine"].Api.Layers.showLayer("sxt", false);
    // window['engine'].Api.Layers.showLayer("DianWang", false);

    window["engine"].Api.Layers.getLayerMeshs("DianWang", (a, b) => {
      let arr = b.split(";");
      arr.map((m) => {
        window["engine"].Api.MeshInfo.setVisible("DianWang", m, false);
        return true;
      });
    });
    window["engine"].Api.MeshInfo.setVisible("Build", "suibian", true);
  }

  /*16进制 颜色转为 RGB 格式*/
  public static colorRGBA(sColor, opacity) {
    // 颜色转换
    let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    sColor = sColor.toLowerCase();
    if (sColor && reg.test(sColor)) {
      if (sColor.length === 4) {
        let sColorNew = "#";
        for (let i = 1; i < 4; i += 1) {
          sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
        }
        sColor = sColorNew;
      }
      //处理六位的颜色值
      let sColorChange: Array<number> = [];
      for (let i = 1; i < 7; i += 2) {
        sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
      }
      return "RGBA(" + sColorChange.join(",") + ", " + opacity + ")";
    } else {
      return sColor;
    }
  }

  public static colorHex(str) {
    var reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
    if (!reg.test(str)) {
      return;
    }
    let newStr = str.toLowerCase().replace(/\#/g, "");
    let len = newStr.length;
    if (len === 3) {
      let t = "";
      for (var i = 0; i < len; i++) {
        t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
      }
      newStr = t;
    }
    let arr: any = []; //将字符串分隔，两个两个的分隔
    for (let i = 0; i < 6; i = i + 2) {
      let s = newStr.slice(i, i + 2);
      arr.push(parseInt("0x" + s));
    }
    return "rgb(" + arr.join(",") + ")";
  }

  public static NumKilobit(num) {
    if (num) {
      if (isNaN(num)) {
        alert("金额中含有不能识别的字符");
        return;
      }
      num = typeof num == "string" ? parseFloat(num) : num; //判断是否是字符串如果是字符串转成数字
      num = num.toFixed(2); //保留两位
      num = parseFloat(num); //转成数字
      num = num.toLocaleString(); //转成金额显示模式
      //判断是否有小数
      if (num.indexOf(".") === -1) {
        // num = num + ".00";
      } else {
        num = num.split(".")[1].length < 2 ? num + "0" : num;
      }
      return num; //返回的是字符串23,245.12保留2位小数
    } else {
      return (num = null);
    }
  }
  /**加载echarts*/
  static initEcharts(dom: string, option) {
    // let echartsDiv: any = document.getElementById(dom);
    // if (echartsDiv) {
    //   let myChart = echarts.getInstanceByDom(echartsDiv);
    //   if (myChart == null) {
    //     myChart = echarts.init(echartsDiv);
    //   }
    //   myChart.setOption(option);
    // }
    let chartDom = document.getElementById(dom);
    chartDom && echarts.dispose(chartDom);
    chartDom && echarts.init(chartDom).setOption(option);
  }

  static countTotal(data: any, type?) {
    let total = 0;
    data.map((e) => {
      total = total + Number(type === undefined ? e : e[type]);
    });
    return total;
  }

  /** 判断是否为空 */
  public static isLoad(type: boolean) {
    let dom: any = document.getElementById("mainLoad");
    let numDom: any = document.getElementById("mask-value");
    let maskLine: any = document.getElementById("mask-line");
    let maskTime: any;
    if (type) {
      console.log(maskLine);
      dom.className = "mask";
      let num = 0;
      maskTime = setInterval(() => {
        num =
          num >= 90
            ? Math.floor(Math.random() * 10) + 90
            : num + Math.floor(Math.random() * 10);
        numDom.innerText = num;
        maskLine.style.width = `${num}%`;
        num > 90 && clearInterval(maskTime);
      }, 80);
    } else {
      numDom.innerText = "100";
      maskLine.style.width = "100%";
      setTimeout(() => {
        dom.className = "mask hide";
        numDom.innerText = "0";
        maskLine.style.width = "0%";
      }, 1500);
    }
  }

  // 获取几天日期
  static getTimes(num: number, symbol?: any) {
    // 获取当前日期
    const currentDate = new Date();
    const recentDays: any = [];
    for (let i = num - 1; i >= 0; i--) {
      // 将当前日期减去i天
      const date = new Date(currentDate);
      date.setDate(currentDate.getDate() - i);
      // 获取月份和日期
      const month = date.getMonth() + 1; // 月份从0开始，需要加1
      const day = date.getDate();
      recentDays.push(`${month}${symbol !== undefined ? symbol : "."}${day}`);
    }
    return recentDays;
  }

  // 获取几天日期
  static getDates(num: number) {
    const now = new Date();
    const threeMinutesAgo = new Date(now.getTime() - num * 60000); // 3分钟前的时间
    const hours = threeMinutesAgo.getHours();
    const minutes = threeMinutesAgo.getMinutes();
    const seconds = threeMinutesAgo.getSeconds();
    return `${hours}:${minutes}:${seconds}`;
  }

  // 生成随机数
  static getRandomNumber(min, max) {
    // 使用 Math.random() 生成一个 [0,1) 之间的随机数
    // 将其乘以 (max - min + 1) 并取整，得到一个 [0, max - min + 1) 之间的整数
    // 再加上 min，得到一个 [min, max + 1) 之间的整数
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
